
import { MediaContextProvider, Media } from '../../../mobile'

import { useIsTeacherOnly } from '../../../hooks/isTeacher';

import { TeacherClassesView  } from './teacher/TeacherClassesView';
import { AdminClassesView } from './admin/AdminClassesView';

const Classes = () => {
  // The same correction as `MobileContainer`: the register-taking class list is for people who
  // only teach, not for everybody who is not an administrator. A companion or a class builder
  // on a phone gets the full list, which is the one their other permissions are about.
  const isTeacher = useIsTeacherOnly();

  return (
    <MediaContextProvider>
      <Media at='mobile'>
          {isTeacher ? (
            <TeacherClassesView />
          ): (
            <AdminClassesView />
          )}
      </Media>
      <Media greaterThan='mobile'>
        {/* NOTE: this is shown for more than just admins at this time */}
        <AdminClassesView />
      </Media>
    </MediaContextProvider>
  );
}

export { Classes }
